import { memo } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Button from '@core/design-system/button';
import Typography from '@mui/material/Typography';

import { PremiumIcon } from './icon';
import { IPremiumTooltipProps } from './interface';
import { useTheme } from '@mui/material';
import Image from 'next/image';

export const PrimeTooltip = memo<IPremiumTooltipProps>(
  ({ children, link, userIsPrime }) => {
    const theme = useTheme();

    if (userIsPrime) return children;

    return (
      <Tooltip
        componentsProps={{ tooltip: { sx: { p: 0 } } }}
        title={
          <Box
            borderRadius={1}
            textAlign="center"
            sx={{
              py: 3,
              px: 2,
              background: theme.palette.primary.main,
              maxWidth: '240px',
            }}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Box
              height={48}
              width={48}
              bgcolor="#3F4255"
              mb={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="50%"
            >
              <Image
                src="/images/prime-icon.svg"
                alt=""
                height={32}
                width={32}
              />
            </Box>
            <Typography
              fontWeight={700}
              variant="h4"
              color={theme.palette.primary.contrastText}
              gutterBottom
            >
              Recurso exclusivo Retorno Prime
            </Typography>

            <Typography
              variant="body2"
              color={theme.palette.primary.contrastText}
              mb={3}
            >
              Para visualizar estes dados e obter outras vantagens, torne-se
              Prime.
            </Typography>

            <Button
              target="_blank"
              href={link}
              rel="noopener"
              variant="contained"
              color="secondary"
              sx={{
                textTransform: 'none',
                color: theme.palette.primary.main,
              }}
            >
              Assinar agora
            </Button>
          </Box>
        }
      >
        {children}
      </Tooltip>
    );
  }
);
